// src/pages/ChangePassword.jsx
import React, { useState } from 'react';
import { apiPost } from '../api/http';
import { useAuth } from '../auth/AuthContext';
import './login.css'; // reuse same card styling for uniform look

export default function ChangePassword() {
  const { logout } = useAuth();
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (newPassword !== confirm) {
      setMessage('New passwords do not match');
      return;
    }
    setLoading(true);
    setMessage('');
    try {
      const res = await apiPost('/api/auth/change-password', {
        oldPassword,
        newPassword,
      });
      setMessage(res.message || 'Password updated successfully');
      // 🔹 Auto logout after password change for security
      setTimeout(() => logout(), 2000);
    } catch (err) {
      setMessage('Failed to update password. Please check your old password.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <h2>Change Password</h2>
        <p className="subtitle">Update your account password</p>

        {message && <div style={{ marginBottom: '1em', color: '#333' }}>{message}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <input
              type="password"
              placeholder="Old password"
              value={oldPassword}
              onChange={(e) => setOldPassword(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <input
              type="password"
              placeholder="New password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <input
              type="password"
              placeholder="Confirm new password"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              required
            />
          </div>
          <button className="login-btn" type="submit" disabled={loading}>
            {loading ? 'Updating…' : 'Change Password'}
          </button>
        </form>
      </div>
    </div>
  );
}
